import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
// core
import {
  Avatar,
  Button,
  Checkbox,
  FormControlLabel,
  Grid,
} from '@material-ui/core';

// icons
import RadioButtonUnchecked from '@material-ui/icons/RadioButtonUnchecked';
import RadioButtonChecked from '@material-ui/icons/RadioButtonChecked';

import Select from '../../Select';
import Modal from '../../Modal';

import EmojiForm from './emojiForm';

import useStyles from '../styles';
import QuestionShell from '../QuestionShell';
import useQuestionForm from '../QuestionShell/useQuestionForm';

import { VIEW_MODE } from '../../../utils/const/taskModes';

import { S3_EMOJIS_BUCKET, emojiSchema } from '../../../utils/const/emojis';

function Satisfaction({
  identifier, pages, info, handleDeleteQuestion, editMode,
  mode, handleDuplicateQuestion,
}) {
  const styles = useStyles();
  const { t } = useTranslation();

  const [checkBox, setCheckBox] = useState(null);
  const [feedbackScale, setfeedbackScale] = useState(info ? info.emojiScale : '');
  const [emojiSet, setEmojiSet] = useState(info ? info.emojiSet : 'emojiSet1');
  const [openEmojiSet, setOpenEmojiSet] = useState(false);

  const question = useQuestionForm({
    identifier, pages, info, autoLoadMedia: false,
  });
  const {
    image, setImage, setEmailsArray, setSendEmail, writePage, questionLogic,
  } = question;

  useEffect(() => {
    if (info !== undefined) {
      setImage({
        ...image,
        url: info.imageUrl,
        name: info.imageKey,
      });
      if (
        info.QuestionEmails !== undefined
        && info.QuestionEmails.length !== 0) {
        setEmailsArray(info.QuestionEmails[0].emails.split(','));
      }
      setSendEmail(info.sendEmail);
    } else {
      if (pages && pages[identifier - 1].imageUrl) {
        setImage({
          ...image,
          url: pages[identifier - 1].imageUrl,
          name: pages[identifier - 1].imageKey,
        });
      }

      if (
        pages[identifier - 1].questionEmails !== undefined
        && pages[identifier - 1].questionEmails.length !== 0) {
        setEmailsArray(pages[identifier - 1].questionEmails[0].emails.split(','));
      }
      setSendEmail(pages[identifier - 1].sendEmail);
    }
    // Se busca que en modo EDICIÓN se cargue el feedbackScale
    // es modo EDICIÓN si se entrega deleted questions.
    if (editMode) {
      if (pages[identifier - 1].emojiScale) {
        setfeedbackScale(pages[identifier - 1].emojiScale);
      } else {
        setfeedbackScale('');
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleCheck = (event) => {
    setCheckBox(event.target.name);
  };

  const handleFeedbackScale = (event) => {
    const { value } = event.target;
    setfeedbackScale(Number.parseInt(value, 10));

    writePage({
      emojiScale: value,
      emojiSet,
      questionChoices: null,
      questionLogic,
    });
  };

  const handleEmojiSet = (value) => {
    writePage({
      emojiSet: value,
      questionChoices: null,
      questionLogic,
    });
  };

  const concatString = (first, second, third, fourth) => first + second + third + fourth;

  return (
    <QuestionShell
      {...question}
      identifier={identifier}
      info={info}
      mode={mode}
      titleKey="task.taskEdition.satisfactionText.question"
      descriptionAs="none"
      actionsInGrid
      extraActions={
        <Button
          onClick={() => setOpenEmojiSet(true)}
          disabled={mode === VIEW_MODE}
        >
          {t('task.taskEdition.satisfactionText.editEmojiSet')}
        </Button>
      }
      handleDeleteQuestion={handleDeleteQuestion}
      handleDuplicateQuestion={handleDuplicateQuestion}
      footer={openEmojiSet ? (
        <Modal
          title={t('task.taskEdition.satisfactionText.selectEmojiSet')}
          defaultOpen={openEmojiSet}
          setCurrentOpen={setOpenEmojiSet}
        >
          <EmojiForm
            setCurrentOpen={setOpenEmojiSet}
            emojiSet={emojiSet}
            setEmojiSet={setEmojiSet}
            handleEmojiSet={handleEmojiSet}
            bucket={S3_EMOJIS_BUCKET}
          />
        </Modal>
      ) : null}
    >
      <Select
        name="feedbackOptions"
        className={styles.description}
        items={[
          { name: t('task.taskEdition.satisfactionText.select'), value: '' },
          { name: t('task.taskEdition.satisfactionText.twoOptions'), value: '2' },
          { name: t('task.taskEdition.satisfactionText.threeOptions'), value: '3' },
          { name: t('task.taskEdition.satisfactionText.fourOptions'), value: '4' },
          { name: t('task.taskEdition.satisfactionText.fiveOptions'), value: '5' },
          { name: t('task.taskEdition.satisfactionText.sixOptions'), value: '6' },
        ]}
        value={info ? info.feedbackScale : feedbackScale}
        onChange={handleFeedbackScale}
        fullWidth
        disabled={mode === VIEW_MODE}
      />
      <Grid container className={styles.emojiGrid}>
        {feedbackScale !== '' && emojiSchema[feedbackScale] ? emojiSchema[feedbackScale].map((item) => (
          <Grid key={item} className={styles.labels} item xs>
            <div key={item} className={styles.checkboxesContainer}>
              <FormControlLabel
                className={styles.checkbox}
                control={
                  <div>
                    <Checkbox
                      icon={<RadioButtonUnchecked />}
                      checkedIcon={<RadioButtonChecked style={{ color: 'green' }} />}
                      name="1"
                      checked={checkBox === '1'}
                      disabled
                    />
                  </div>
                }
                label={<Avatar
                  className={styles.avatar}
                  src={concatString(S3_EMOJIS_BUCKET, '/', emojiSet, item)}
                />}
                onChange={handleCheck}
              />
            </div>
          </Grid>
        )) : null}
      </Grid>
    </QuestionShell>
  );
}

export default Satisfaction;
